// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ep-spinner[data-v-527487ee] {\n  animation: spin-data-v-527487ee 1s linear infinite;\n  width: 1.5rem;\n  height: 1.5rem;\n  color: #BD0F72;\n}\n.ep-spinner .circle[data-v-527487ee] {\n  opacity: 0.25;\n}\n.ep-spinner .path[data-v-527487ee] {\n  opacity: 0.75;\n}\n@keyframes spin-data-v-527487ee {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}", ""]);
// Exports
module.exports = exports;
